<ami-dialog-message [setting]="message"></ami-dialog-message>
<p-toast></p-toast>

<ami-table-actions
  [settings]="table.settings"
  [data]="table.data"
  [actions]="table.actions"
  (action)="onReciveAction($event); onReciveActionHead($event)"
  [actionsHead]="table.actionsHead"
></ami-table-actions>

<ami-dialog-confirm
  [setting]="confirmSettings"
  (confirmed)="actionConfirmed($event)"
></ami-dialog-confirm>

<ng-container *ngIf="showOpenPurchaseOrderReceptionCreate">
  <pg-purchase-order-reception-create
    (close)="showOpenPurchaseOrderReceptionCreate = false"
  ></pg-purchase-order-reception-create>
</ng-container>

<div *ngIf="dataDocument">
  <pg-purchase-order-reception-detail
    [dataDocument]="dataDocument"
    (onHideData)="dataDocument = undefined"
  >
  </pg-purchase-order-reception-detail>
</div>
